export const TREND_ASSETS_CHECKBOXES = [
  { value: 'BS2', color: '#006AA6', isBarChart: true },
  { value: 'FA004', color: '#C3D785', isBarChart: true },
  { value: 'BS18', color: '#E3A2A7', isBarChart: true },
  { value: 'FA005', color: '#AE93E1', isBarChart: true },
  { value: 'FA006', color: '#00A8B5', isBarChart: true },
  { value: 'RT0172', color: '#F49966', isLineChart: true },
]

export const TREND_LIABILITIES_CHECKBOXES = [
  { value: 'FA013', color: '#006AA6', isBarChart: true },
  { value: 'FA016', color: '#C3D785', isBarChart: true },
  { value: 'FA015', color: '#E3A2A7', isBarChart: true },
  { value: 'FA014', color: '#AE93E1', isBarChart: true },
  { value: 'FA017', color: '#00A8B5', isBarChart: true },
  { value: 'FA018', color: '#F49966', isLineChart: true },
]

export const TREND_EQUITY_CHECKBOXES = [
  { value: 'FA024', color: '#006AA6', isBarChart: true },
  { value: 'BS109', color: '#C3D785', isBarChart: true },
  { value: 'FA025', color: '#E3A2A7', isBarChart: true },
  { value: 'RT0173', color: '#F49966', isLineChart: true },
]

export const EACH_YEAR = {
  ASSETS: [
    { id: 'FA152', color: '#006AA6' },
    { id: 'FA007', color: '#F49966' },
    { id: 'FA008', color: '#00A8B5' },
    { id: 'FA009', color: '#D96383' },
    { id: 'FA010', color: '#74B49A' },
    { id: 'FA011', color: '#7F63B9' },
    { id: 'FA012', color: '#FFCD60' },
  ],
  PARENT_PIE: [
    { id: 'BS65', color: '#0553A5' },
    { id: 'BS95', color: '#FFCD60' },
  ],
  CHILD_PIE: {
    BS65: [
      { id: 'FA019', color: '#4EB1CB' },
      { id: 'FA020', color: '#F49966' },
      { id: 'FA021', color: '#717ECD' },
      { id: 'FA022', color: '#C3D785' },
      { id: 'FA023', color: '#EC838C' },
    ],
    BS95: [
      { id: 'FA026', color: '#4EB1CB' },
      { id: 'FA027', color: '#F49966' },
      { id: 'FA028', color: '#717ECD' },
    ],
  },
}

export const TABLE_TABS = [
  {
    label: 'financialAnalysis.ASSET_STRUCTURE',
    key: 0,
    rowIds: [
      'BS2',
      'FA003',
      'FA004',
      'BS18',
      'FA005',
      'FA006',
      'BS64',
      'RT0172',
    ],
  },
  {
    label: 'financialAnalysis.LIABILITIES_STRUCTURE',
    key: 1,
    rowIds: ['FA013', 'FA016', 'FA015', 'FA014', 'FA017', 'BS65', 'FA018'],
  },
  {
    label: 'financialAnalysis.EQUITY_STRUCTURE',
    key: 2,
    rowIds: ['FA024', 'BS109', 'FA025', 'BS95', 'RT0173'],
  },
]
